import React, { useContext, useEffect, useState } from 'react';
import { RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import styles from './RPSOCRDeliveryMethod.css';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import { uspsText, docuSignText, getDisplayText } from './utils';
import { rpsDeliveryMethodTypes } from '../../flows/front-office/shared/utils';

const RPSOCRDeliveryMethodReview = ({ ocrDeliveryMethod }) => {
  const deliveryDisplayText = getDisplayText(ocrDeliveryMethod);

  return (
    <>
      {ocrDeliveryMethod ? (
        <div className="review-section">
          <div className="field-value">{deliveryDisplayText}</div>
        </div>
      ) : (
        <div className="no-selection">
          You have not made any selections yet.
        </div>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

const RPSOCRDeliveryMethod = ({
  editDeliveryMethod,
  setEditDeliveryMethod
}) => {
  const {
    appState: {
      store: {
        loadedData: { ocrDeliveryMethod, deliveryEditMode }
      }
    },
    formProps,
    next
  } = useContext(FlowContext);

  const [deliveryMethod, setDeliveryMethod] = useState(ocrDeliveryMethod);

  useEffect(() => {
    setEditDeliveryMethod(deliveryEditMode);
  }, [deliveryEditMode]);

  const handleClick = async () => {
    if (editDeliveryMethod) {
      await next({
        section: 'ocrDeliveryMethod',
        deliveryType: deliveryMethod
      })();
    } else {
      await next('unlockRPSDeliverySection')();
    }
  };

  const handleDeliveryMethod = ({ target: { value } }) => {
    setDeliveryMethod(value);
  };

  const isValid =
    deliveryMethod === rpsDeliveryMethodTypes.USPS ||
    deliveryMethod === rpsDeliveryMethodTypes.DOCUSIGN;

  const radioOptions = [
    {
      title: uspsText,
      value: rpsDeliveryMethodTypes.USPS,
      defaultChecked: deliveryMethod === rpsDeliveryMethodTypes.USPS
    },
    {
      title: docuSignText,
      value: rpsDeliveryMethodTypes.DOCUSIGN,
      defaultChecked: deliveryMethod === rpsDeliveryMethodTypes.DOCUSIGN
    }
  ];

  return (
    <div>
      <div className="section-header">
        <SectionHeading text="Delivery Method" />
      </div>
      {editDeliveryMethod ? (
        <div className="section-content">
          <div className="delivery-option-input">
            <RadioGroupField
              options={radioOptions}
              vertical
              onChange={handleDeliveryMethod}
              {...formProps.deliveryType}
              name="deliveryType"
            />
          </div>
        </div>
      ) : (
        <RPSOCRDeliveryMethodReview ocrDeliveryMethod={ocrDeliveryMethod} />
      )}
      <EditButton
        onClick={handleClick}
        currentlyEditing={editDeliveryMethod}
        disabled={!isValid}
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default RPSOCRDeliveryMethod;
